import styled from "styled-components";
import { padding, rgba } from "polished";
import { Lightbox } from "../lightbox/lightbox.es.js";
const TokenInputInner = styled("div")(
  ({ theme }) => ({
    alignItems: "center",
    border: `1px solid ${theme.controlBorderColor}`,
    borderRadius: 2,
    boxSizing: "border-box",
    cursor: "text",
    display: "flex",
    flexWrap: "wrap",
    fontFamily: theme.fontFamily.default,
    fontSize: theme.fontSize.default,
    gap: 4,
    minHeight: 32,
    minWidth: 150,
    ...padding(4, 11),
    position: "relative",
    "&:focus": {
      outline: "none"
    }
  }),
  ({ disabled, theme }) => disabled ? {
    backgroundColor: "rgba(0, 0, 0, 0.05)",
    color: "rgba(0, 0, 0, 0.25)"
  } : {
    "&:hover": {
      borderColor: theme.color.blue6
    },
    "&:focus": {
      borderColor: theme.color.blue6,
      boxShadow: `0 0 0 2px ${rgba(theme.color.blue6, 0.25)}`
    }
  },
  ({ "aria-expanded": expanded, theme }) => expanded ? {
    borderColor: theme.color.blue6,
    boxShadow: `0 0 0 2px ${rgba(theme.color.blue6, 0.2)}`
  } : void 0
);
const TokenInputWrapper = styled("div")({
  position: "relative"
});
const TokenLightbox = styled(Lightbox)({
  padding: 4,
  maxHeight: 280
});
export {
  TokenInputInner,
  TokenInputWrapper,
  TokenLightbox
};
